const companyIdObject = {
    "35001114025":"All Japan Real Estate Association",
    "35000894493":"AQR International Ltd",
    "35001025704":"BCG",
    "35000894489":"Calypso Technology",
    "35000894491":"Canyon Partners",
    "35000657203":"Cartier",
    "35001114041":"CBS",
    "35001114042":"Chugai Clinical Research Center",
    "35001114037":"Chugai Pharmaceutical",
    "35001114038":"CHUO MINATOKAI",
    "35001057364":"CITI",
    "35001181470":"Client Trial (TPO)",
    "35000894487":"CVPC",
    "35001114033":"Denka Company",
    "35000511390":"Dentsu",
    "35000894490":"E.SUN Commercial Bank",
    "35001009513":"ER Trial (TPO)",
    "35001046233":"Events",
    "35001026668":"Family",
    "35001059498":"Goldman Sachs",
    "35000894492":"HarbourVest Partners (Japan) Limited",
    "35001114017":"HIMEDIC",
    "35001181472":"Internal Research (TPO)",
    "35001114003":"Japan WillTech Solution",
    "35001114015":"Kanazawa University",
    "35001256115":"KKE",
    "35001049732":"KPMG",
    "35000894488":"LinkedIn Japan",
    "35001114030":"Lotus Estate",
    "35001114007":"Mikado Coffee Shokai",
    "35000516945":"Mitsubishi Estate",
    "35000119970":"Mitsui Fudosan",
    "35001112531":"Mitsui Fudosan Building Management",
    "35001112533":"Mitsui Fudosan Residential",
    "35001114026":"Mitsuifudosan TG Smart Energy",
    "35001048964":"Mori Building",
    "35001026653":"mot. Member's Lounge",
    "35001114034":"Muromachi Dental",
    "35001064691":"MyAccount",
    "35001114005":"NEC Networks & System Integration",
    "35001114006":"Nishimoto",
    "35001048974":"Nishimura & Asahi",
    "35001057363":"NSF",
    "35000333164":"NTT Data",
    "35000564654":"NTT Data 第四金融事業本部",
    "35000894486":"NVCC",
    "35001238370":"OCA Tokyo",
    "35001034465":"Other",
    "35001056421":"Paypay",
    "35001114036":"QUICK",
    "35001053818":"Quipper Japan",
    "35001213211":"Research Specialist(TPO)",
    "35001009865":"Robert Walters",
    "35001206431":"RUF",
    "35001261628":"Salesforce",
    "35001181471":"Sample Report (TPO)",
    "35000894494":"Shift Technology",
    "35001023889":"Singapore Government Agency",
    "35000516944":"Sunny Side Up",
    "35001114027":"Susaki Welfare Foundation",
    "35001114022":"TANACHO",
    "35001114013":"The Hokkaido Bank",
    "35001114012":"The Hokuriku Bank",
    "35000894238":"The Premier Floor",
    "35001114021":"Tokyo American Club",
    "35001114031":"TORAY INDUSTRIES",
    "35001114040":"Toray Intellectual Property Center",
    "35001114039":"TOYO BUSINESS SUPPORT",
    "35001261629":"Wellness",
    "35001114043":"Toyota Motor",
    "35001114044":"Work Styling Nihonbashi Mitsui Tower",
    "35000131126":"TPO",
    "35001114004":"TRI-AD",
    "35000695111":"VIP",
    "35001114029":"Wave Real Estate",
    "35001114028":"Wismettac Foods",
}

export default companyIdObject;
